module.exports = __webpack_public_path__ + "static/media/cross-icon.f8c4c0a1.svg";